import { observer } from 'mobx-react';
import React from 'react';

import MediaTypography from 'components/MediaTypography';
import { Formik } from 'formik';
import GoalFormToDoList from 'modules/Report/components/GoalFormToDoList';
import store from 'store';

import { postGoal } from '@common/api/goals';
import { postSteps } from '@common/api/goalsSteps';
import { postMainGoal } from '@common/api/mainGoals';
import GoalsImageSrc from '@common/assets/images/about-me/goals/goals_lg.jpg';

import {
	StyledGoalsCreateButton,
	StyledGoalsCreateStepsImg,
	StyledGoalsCreateStepsPaper,
} from '../styled';
import { StyledGoalsCreateStep3Form, StyledGoalsCreateStep3FormItems } from './styled';

interface PropsType {
	onClick: () => void;
	mainGoal: string;
	title: string;
}

function GoalsCreateStep3({ onClick, mainGoal, title }: PropsType) {
	const handleSubmit = async (data: any) => {
		try {
			const mainGoalResult = await postMainGoal({ title: mainGoal });
			const result = await postGoal({
				main_goal_id: mainGoalResult?.id,
				title,
			});
			postSteps({
				steps: [
					...data.steps.map((step: any) => ({
						goal_id: result.id,
						title: step.title,
					})),
				],
			});
			onClick();
		} catch (e) {
			console.info(e);
		}
	};

	return (
		<Formik onSubmit={handleSubmit} initialValues={{ steps: [] }}>
			{({ values }) => (
				<StyledGoalsCreateStep3Form>
					<>
						<StyledGoalsCreateStepsPaper>
							<StyledGoalsCreateStepsImg alt="create goal step 2" src={GoalsImageSrc} />
							<StyledGoalsCreateStep3FormItems>
								<MediaTypography
									variant="h3"
									variants={{ sm: 'h4' }}
									textColor="secondary"
									sx={{ textAlign: 'center' }}
								>
									Specify the main stages that will help to achieve the goal of “{title}”
								</MediaTypography>
								<GoalFormToDoList name="steps" />
							</StyledGoalsCreateStep3FormItems>
						</StyledGoalsCreateStepsPaper>
						<StyledGoalsCreateButton
							type="submit"
							variant="contained"
							disabled={values.steps.length < 1 || !store.isSelfStudentView}
						>
							Complete
						</StyledGoalsCreateButton>
					</>
				</StyledGoalsCreateStep3Form>
			)}
		</Formik>
	);
}

export default observer(GoalsCreateStep3);
